/*
 * @Description: 业务管理系统
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
 */
import request from '@/utils/request'
export const Download = "/base/system/data/limits/export";

export function batchUpdateOrDelete(data) {
	return request({
		url: '/base/system/data/limits/batch_update_or_delete',
		method: 'post',
		data
	})
}
export function getDetail(params) {
	return request({
		url: '/base/system/data/limits/get_detail',
		method: 'get',
		params
	})
}
export function queryPage(data) {
	return request({
		url: '/base/system/data/limits/query_page',
		method: 'post',
		data
	})
}
export function queryLimitByAuth(data) {
	return request({
		url: '/base/system/data/limits/getDataLimitByUserAuthList',
		method: 'post',
		data
	})
}
export function saveOrUpdate(data) {
	return request({
		url: '/base/system/data/limits/save_or_update',
		method: 'post',
		data
	})
}
export function updateSortNum(data) {
	return request({
		url: '/base/system/data/limits/update_sort_num',
		method: 'post',
		data
	})
}

